import {
  React,
  useState,
  useEffect,
  LoaderOverlay,
  withAuth,
  toast,
  connect,
  useDispatch,
  useSelector,
  useNavigate,
  MESSAGES,
} from "./../../common/helper/common-imports.component.js";
import {
  RowsPerPageSelector,
  SearchTable,
  DataTable,
  customDataTableStyles,
} from "./../../common/helper/table-imports.js";
import { useLocation } from "react-router-dom";
import LoginService from "./../../../services/auth-service";
import ConfigService, {
  useUserCheckPermission,
  useUserPermission,
} from "../../../services/config-service";
import { useClass } from "./../../../contexts/classContext";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import BusinessIcon from "@mui/icons-material/Business";
import SupervisorAccountIcon from "@mui/icons-material/SupervisorAccount";
import AccountTreeOutlinedIcon from "@mui/icons-material/AccountTreeOutlined";
import WifiProtectedSetupOutlinedIcon from "@mui/icons-material/WifiProtectedSetupOutlined";
import Groups2OutlinedIcon from "@mui/icons-material/Groups2Outlined";
import SpeedOutlinedIcon from "@mui/icons-material/SpeedOutlined";
import AttachMoneyOutlinedIcon from "@mui/icons-material/AttachMoneyOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import HelpCenterOutlinedIcon from "@mui/icons-material/HelpCenterOutlined";
import Diversity3OutlinedIcon from "@mui/icons-material/Diversity3Outlined";
import CurrencyBitcoinIcon from "@mui/icons-material/CurrencyBitcoin";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import useIsMobile from "../hooks/useIsMobile";
import Switch from "@mui/material/Switch";
import AutoPayService from "../../../services/auto-pay.service.js";
import { getUser } from "./../../../actions/auth-actions";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";

function Sidebar() {
  const { toggleClass, myClass } = useClass();
  const isMobile = useIsMobile();
  const hasFundTransferPermission =
    ConfigService.checkUserPermission("fund_transfer");
  const hasViewFundListingPermission =
    ConfigService.checkUserPermission("view_fund_listing");
  const hasSearchTransaction =
    ConfigService.checkUserPermission("search_transaction");
  const [activeLink, setActiveLink] = useState(null);
  const label = { inputProps: { "aria-label": "Switch demo" } };
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector((state) => state.authReducer);
  console.log(userData);
  const [userRole, setUserRole] = useState();
  useEffect(() => {
    const pathname = location.pathname.substring(1);
    if (pathname === "add-merchant") {
      setActiveLink("merchants"); // If the pathname is "add-merchant", keep "Merchants" active
    } else if (pathname.includes("approve-agent")) {
      setActiveLink("agents");
    } else if (pathname.includes("view-agent")) {
      setActiveLink("agents");
    } else if (pathname.includes("edit-agent")) {
      setActiveLink("agents");
    } else if (pathname.includes("view-merchant")) {
      setActiveLink("merchants");
    } else if (pathname.includes("edit-merchant")) {
      setActiveLink("merchants");
    } else if (
      pathname.includes("add-agent-limit") ||
      pathname.includes("view-agent-limits")
    ) {
      setActiveLink("limits");
    } else if (
      pathname.includes("add-commission-group") ||
      pathname.includes("view-commission")
    ) {
      setActiveLink("commission-groups");
    } else if (pathname == "admin-payments") {
      setActiveLink("admin-payments");
    } else if (pathname == "transaction") {
      setActiveLink("transactions");
    } else if (pathname == "raised-transactions") {
      setActiveLink("raised-transactions");
    } else if (pathname.includes("lifecycle")) {
      setActiveLink("transactions");
    } else if (pathname.includes("user")) {
      setActiveLink("users");
    } else if (pathname.includes("edit-commission")) {
      setActiveLink("commission");
    } else if (pathname.includes("commssion-view")) {
      setActiveLink("commission");
    } else if (pathname == "crypto-list") {
      setActiveLink("crypto-list");
    } else if (pathname == "crypto-config") {
      setActiveLink("crypto-config");
    } else if (pathname.includes("update-files")) {
      setActiveLink("crypto-config");
    } else if (pathname.includes("crypto")) {
      setActiveLink("crypto");
    } else {
      setActiveLink(pathname || "dashboard"); // Otherwise, set active link based on pathname
    }
    if (userData && userData.user && userData.user.data) {
      console.log(userData.user.data.role);
      setUserRole(userData.user.data.role.role_name);
    }
  }, [location]);

  const handleLinkClick = (linkId) => {
    console.log(linkId);
    setActiveLink(linkId);
    if (linkId == "crypto") {
      navigate(linkId + "?userType=agent");
    } else {
      navigate(linkId);
    }

    if (window.innerWidth < 992) {
      toggleClass();
    }
  };

  const setAutoPay = () => {
    setLoading(true);
    const data = {};
    data.agents = [userData?.user?.data?.user_id];
    data.auto_pay = userData?.user?.data?.auto_pay ? false : true;
    AutoPayService.setAutoPay(data)
      .then((response) => {
        toast.success(MESSAGES.AUTO_PAY);
        dispatch(getUser());

        setLoading(false);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };
  const setAutoPaySystem = () => {
    setLoading(true);
    const data = {};
    data.auto_pay = userData?.user?.data?.auto_pay ? false : true;
    AutoPayService.setAutoPaySystemUpdate(data)
      .then((response) => {
        toast.success("Settings updated successfully.");
        dispatch(getUser());

        setLoading(false);
      })
      .catch((error) => {
        const errorMessage = error.response.data;
        toast.error(errorMessage.error.message || MESSAGES.SERVER_ERROR);
        setLoading(false);
      });
  };

  return (
    <>
      <LoaderOverlay loading={loading} />
      <div id="layoutSidenav_nav">
        {myClass !== "sb-sidenav-toggled" && (
          <div
            className="d-flex sb-sidenavBar-theme-color"
            style={{ padding: "20px 0px", paddingLeft: "10px" }}
          >
            <img width={180} src={process.env.REACT_APP_LOGO_URL} />
          </div>
        )}

        <nav
          className="sb-sidenav accordion sb-sidenav-light adjust-height-small-device"
          id="sidenavAccordion"
          style={{ backgroundColor: "#2e3345!important" }}
        >
          <div className="sb-sidenav-menu">
            <div className="nav">
              {ConfigService.checkUserPermission("dashboard_agent") && (
                <div className="mt-2">
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "dashboard" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("dashboard")}
                      >
                        {/* <i className="fa fa-windows fs-4" /> */}
                        <PollOutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "dashboard" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("dashboard")}
                    >
                      <div className="sb-nav-link-icon">
                        <PollOutlinedIcon />
                        {/* <i className="fa fa-windows fs-5" /> */}
                      </div>{" "}
                      Dashboard
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("dashboard_owner") && (
                <div className="mt-2">
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "admin-dashboard" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("admin-dashboard")}
                      >
                        <PollOutlinedIcon />
                        {/* <i className="fa fa-windows fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "admin-dashboard" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("admin-dashboard")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-windows fs-5" /> */}
                        <PollOutlinedIcon />
                      </div>{" "}
                      <span>Dashboard</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("dashboard_merchant") && (
                <div className="mt-2">
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "merchant-dashboard" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("merchant-dashboard")}
                      >
                        {/* <i className="fa fa-windows fs-4" /> */}
                        <PollOutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "merchant-dashboard" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("merchant-dashboard")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-windows fs-5" /> */}
                        <PollOutlinedIcon />
                      </div>{" "}
                      <span>Dashboard</span>
                    </a>
                  )}
                </div>
              )}

              {ConfigService.checkUserPermission("user_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "users" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("users")}
                      >
                        <ManageAccountsOutlinedIcon />
                        {/* <i className="fa fa-user fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "users" ? "active" : ""
                      }`}
                      style={
                        {
                          // marginTop:
                          //  funcToCheckROle("dashboard_agent") ||
                          //  funcToCheckROle("dashboard_owner") ||
                          //  funcToCheckROle("dashboard_merchant")
                          //     ? "0"
                          //     :
                          // "15px",
                        }
                      }
                      onClick={() => handleLinkClick("users")}
                    >
                      <div className="sb-nav-link-icon">
                        <ManageAccountsOutlinedIcon />
                        {/* <i className="fa fa-user fs-5" /> */}
                      </div>{" "}
                      <span>User Managment</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("auto_pay") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "auto-pay" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("auto-pay")}
                      >
                        <AutoFixHighIcon />
                        {/* <i className="fa fa-user fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "auto-pay" ? "active" : ""
                      }`}
                      style={
                        {
                          // marginTop:
                          //  funcToCheckROle("dashboard_agent") ||
                          //  funcToCheckROle("dashboard_owner") ||
                          //  funcToCheckROle("dashboard_merchant")
                          //     ? "0"
                          //     :
                          // "15px",
                        }
                      }
                      onClick={() => handleLinkClick("auto-pay")}
                    >
                      <div className="sb-nav-link-icon">
                        <AutoFixHighIcon />
                        {/* <i className="fa fa-user fs-5" /> */}
                      </div>{" "}
                      <span>Auto Pay</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("agent_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "agents" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("agents")}
                      >
                        {/* <i className="fa fa-list fs-4" /> */}
                        <SupervisorAccountIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "agents" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("agents")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-list fs-5" /> */}
                        <SupervisorAccountIcon />
                      </div>{" "}
                      <span>Agents</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("merchant_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "merchants" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("merchants")}
                      >
                        {/* <i className="fa fa-list fs-4" /> */}
                        <BusinessIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "merchants" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("merchants")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-list fs-5" /> */}
                        <BusinessIcon />
                      </div>{" "}
                      <span>Merchants</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("distributor_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "distributors" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("distributors")}
                      >
                        {/* <i className="fa fa-industry fs-4" /> */}
                        <AccountTreeOutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "distributors" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("distributors")}
                    >
                      <div className="sb-nav-link-icon">
                        <AccountTreeOutlinedIcon />
                      </div>{" "}
                      Distributors
                    </a>
                  )}
                </div>
              )}
              {(hasFundTransferPermission || hasViewFundListingPermission) && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end 
          
           `}
                    >
                      <div className="sb-nav-link-icon w-auto">
                        <CompareArrowsOutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className="nav-link collapsed "
                      href="#"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseLayoutsdf119"
                      aria-expanded="false"
                      aria-controls="collapseLayouts"
                    >
                      <div className="sb-nav-link-icon">
                        <CompareArrowsOutlinedIcon />
                      </div>{" "}
                      Fund Transfer{" "}
                      <div className="sb-sidenav-collapse-arrow">
                        <i className="fa fa-angle-down fs-5" />
                      </div>
                    </a>
                  )}
                </div>
              )}
              {(myClass !== "sb-sidenav-toggled" || isMobile) && (
                <div
                  className="collapse"
                  id="collapseLayoutsdf119"
                  aria-labelledby="headingOne"
                  data-bs-parent="#sidenavAccordion"
                  style={{}}
                >
                  {hasViewFundListingPermission && (
                    <nav className="sb-sidenav-menu-nested nav">
                      <a
                        className={`nav-link  ${
                          activeLink === "funds-listing" ? "active" : ""
                        }`}
                        onClick={() => handleLinkClick("funds-listing")}
                      >
                        Statement
                      </a>
                    </nav>
                  )}

                  {hasFundTransferPermission && (
                    <>
                      <nav className="sb-sidenav-menu-nested nav">
                        <a
                          className={`nav-link  ${
                            activeLink === "funds" ? "active" : ""
                          }`}
                          onClick={() => handleLinkClick("funds")}
                        >
                          Deposit
                        </a>
                      </nav>
                      <nav className="sb-sidenav-menu-nested nav">
                        <a
                          className={`nav-link  ${
                            activeLink === "withdraw" ? "active" : ""
                          }`}
                          onClick={() => handleLinkClick("withdraw")}
                        >
                          Withdraw
                        </a>
                      </nav>
                    </>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("transaction_management") &&
                hasSearchTransaction && (
                  <div>
                    {myClass === "sb-sidenav-toggled" && !isMobile ? (
                      <div className={`nav-link  d-flex justify-content-end`}>
                        <div
                          className="sb-nav-link-icon w-auto"
                          // onClick={() => handleLinkClick("cashout")}
                        >
                          {/* <i className="fa fa-exchange fs-4" /> */}
                          <WifiProtectedSetupOutlinedIcon />
                        </div>
                      </div>
                    ) : (
                      <a
                        className="nav-link collapsed "
                        href="#"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseLayoutprofile11"
                        aria-expanded="false"
                        aria-controls="collapseLayouts"
                      >
                        <div className="sb-nav-link-icon">
                          {/* <i className="fa fa-exchange fs-5" /> */}
                          <WifiProtectedSetupOutlinedIcon />
                        </div>{" "}
                        Transactions{" "}
                        <div className="sb-sidenav-collapse-arrow">
                          <i className="fa fa-angle-down fs-5" />
                        </div>
                      </a>
                    )}
                  </div>
                )}
              {(myClass !== "sb-sidenav-toggled" || isMobile) && (
                <div
                  className="collapse"
                  id="collapseLayoutprofile11"
                  aria-labelledby="headingOne"
                  data-bs-parent="#sidenavAccordion"
                  style={{}}
                >
                  {hasSearchTransaction && (
                    <nav className="sb-sidenav-menu-nested nav">
                      <a
                        className={`nav-link   ${
                          activeLink === "system-transactions" ? "active" : ""
                        }`}
                        onClick={() => handleLinkClick("system-transactions")}
                        style={{ cursor: "pointer" }}
                      >
                        {" "}
                        Transactions
                      </a>
                    </nav>
                  )}
                </div>
              )}

              {ConfigService.checkUserPermission("system_summary") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "system-summary" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("system-summary")}
                      >
                        <InsightsOutlinedIcon />
                        {/* <i className="fa fa-desktop fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "system-summary" ? "active" : ""
                      }`}
                      style={{}}
                      onClick={() => handleLinkClick("system-summary")}
                    >
                      <div className="sb-nav-link-icon">
                        <InsightsOutlinedIcon />
                        {/* <i className="fa fa-desktop fs-5" /> */}
                      </div>{" "}
                      <span>System Summary</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("gateway_config") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "gateway-configuration" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("gateway-configuration")}
                      >
                        <i className="fa fa-windows fs-4" />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "gateway-configuration" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("gateway-configuration")}
                    >
                      <div className="sb-nav-link-icon">
                        <i className="fa fa-windows fs-5" />
                      </div>{" "}
                      <span>Gateway Configuration</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("bulk_cashout") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "cashout" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("cashout")}
                      >
                        <i className="fa fa-credit-card fs-4" />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "cashout" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("cashout")}
                    >
                      <div className="sb-nav-link-icon">
                        <i className="fa fa-credit-card fs-5" />
                      </div>{" "}
                      Cashout
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("ticket_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "tickets" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("tickets")}
                      >
                        <HelpCenterOutlinedIcon />
                        {/* <i className="fa fa fa-money fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "tickets" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("tickets")}
                    >
                      <div className="sb-nav-link-icon">
                        <HelpCenterOutlinedIcon />
                        {/* <i className="fa fa fa-money fs-5" /> */}
                      </div>{" "}
                      Tickets
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("payment_method_system") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "admin-payments" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("admin-payments")}
                      >
                        <CreditCardOutlinedIcon />
                        {/* <i className="fa fa fa-money fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "admin-payments" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("admin-payments")}
                    >
                      <div className="sb-nav-link-icon">
                        <CreditCardOutlinedIcon />
                        {/* <i className="fa fa fa-money fs-5" /> */}
                      </div>{" "}
                      Payment Methods
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("commission_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "commissions" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("admin-payments")}
                      >
                        {/* <i className="fa fa-random fs-4" /> */}
                        <Groups2OutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "commissions" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("commissions")}
                    >
                      <div className="sb-nav-link-icon">
                        <Groups2OutlinedIcon />
                        {/* <i className="fa fa-random fs-5" /> */}
                      </div>{" "}
                      Commissions
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission(
                "commission_group_management"
              ) && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "commission-groups" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("commission-groups")}
                      >
                        {/* <i className="fa fa-archive fs-4" /> */}
                        <Diversity3OutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "commission-groups" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("commission-groups")}
                    >
                      <div className="sb-nav-link-icon">
                        <Diversity3OutlinedIcon />
                        {/* <i className="fa fa-archive fs-5" /> */}
                      </div>{" "}
                      Commission Group
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("limit_group_management") && (
                <a
                  className={`nav-link ${
                    activeLink === "limits" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("limits")}
                >
                  <div className="sb-nav-link-icon">
                    <i className="fa fa-database" />
                  </div>{" "}
                  Limits
                </a>
              )}
              {ConfigService.checkUserPermission("payment_method_user") && (
                <a
                  className={`nav-link ${
                    activeLink === "payment-methods" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("payment-methods")}
                >
                  <div className="sb-nav-link-icon">
                    <i className="fa fa-money" />
                  </div>{" "}
                  Payment Methods
                </a>
              )}
              {ConfigService.checkUserPermission("crypto_admin") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div className={`nav-link  d-flex justify-content-end`}>
                      <div
                        className="sb-nav-link-icon w-auto"
                        // onClick={() => handleLinkClick("cashout")}
                      >
                        {/* <i className="fa fa-exchange fs-4" /> */}
                        <CurrencyBitcoinIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className="nav-link collapsed "
                      href="#"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseLayoutprofile111"
                      aria-expanded="false"
                      aria-controls="collapseLayouts"
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-exchange fs-5" /> */}
                        <CurrencyBitcoinIcon />
                      </div>{" "}
                      Crypto{" "}
                      <div className="sb-sidenav-collapse-arrow">
                        <i className="fa fa-angle-down fs-5" />
                      </div>
                    </a>
                  )}
                </div>
              )}
              {(myClass !== "sb-sidenav-toggled" || isMobile) && (
                <div
                  className="collapse"
                  id="collapseLayoutprofile111"
                  aria-labelledby="headingOne"
                  data-bs-parent="#sidenavAccordion"
                  style={{}}
                >
                  <nav className="sb-sidenav-menu-nested nav">
                    <a
                      className={`nav-link  ${
                        activeLink === "crypto-config" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("crypto-config")}
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      Crypto Config
                    </a>
                  </nav>
                  <nav className="sb-sidenav-menu-nested nav">
                    <a
                      className={`nav-link  ${
                        activeLink === "crypto" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("crypto")}
                      style={{ cursor: "pointer" }}
                    >
                      {" "}
                      Crypto Requests
                    </a>
                  </nav>
                </div>
              )}

              {ConfigService.checkUserPermission("crypto_merchant") && (
                <a
                  className={`nav-link ${
                    activeLink === "crypto-list" ? "active" : ""
                  }`}
                  onClick={() => handleLinkClick("crypto-list")}
                >
                  <div className="sb-nav-link-icon">
                    <i className="fa fa-google-wallet" />
                  </div>{" "}
                  Crypto
                </a>
              )}
              {userData?.user?.data?.role?.role_code == "AGENT" && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div className={`nav-link  d-flex justify-content-end `}>
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => setAutoPay("auto-pay")}
                      >
                        <AutoFixHighIcon />
                        {/* <i className="fa fa-user fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link 
                    }`}
                      style={
                        {
                          // marginTop:
                          //  funcToCheckROle("dashboard_agent") ||
                          //  funcToCheckROle("dashboard_owner") ||
                          //  funcToCheckROle("dashboard_merchant")
                          //     ? "0"
                          //     :
                          // "15px",
                        }
                      }
                      onClick={() => setAutoPay("auto-pay")}
                    >
                      <div className="sb-nav-link-icon">
                        <AutoFixHighIcon />
                        {/* <i className="fa fa-user fs-5" /> */}
                      </div>{" "}
                      <span>
                        Auto Pay{" "}
                        <Switch
                          {...label}
                          defaultChecked={
                            userData?.user?.data?.auto_pay ? true : false
                          }
                        />
                      </span>
                    </a>
                  )}
                </div>
              )}

              {userData?.user?.data?.role?.role_code == "ADMIN" && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div className={`nav-link  d-flex justify-content-end `}>
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => setAutoPaySystem("auto-pay")}
                      >
                        <AutoFixHighIcon />
                        {/* <i className="fa fa-user fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link 
                                  }`}
                      style={
                        {
                          // marginTop:
                          //  funcToCheckROle("dashboard_agent") ||
                          //  funcToCheckROle("dashboard_owner") ||
                          //  funcToCheckROle("dashboard_merchant")
                          //     ? "0"
                          //     :
                          // "15px",
                        }
                      }
                      onClick={() => setAutoPaySystem("auto-pay")}
                    >
                      <div className="sb-nav-link-icon">
                        <AutoFixHighIcon />
                        {/* <i className="fa fa-user fs-5" /> */}
                      </div>{" "}
                      <span>
                        System Auto Pay{" "}
                        <Switch
                          {...label}
                          defaultChecked={
                            userData?.user?.data?.auto_pay ? true : false
                          }
                        />
                      </span>
                    </a>
                  )}
                </div>
              )}

              {ConfigService.checkUserPermission("bank_order_pickup") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "scrapper" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("scrapper")}
                      >
                        <PersonSearchIcon />
                        {/* <i className="fa fa-windows fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "scrapper" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("scrapper")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-windows fs-5" /> */}
                        <PersonSearchIcon />
                      </div>{" "}
                      <span>Scrapper</span>
                    </a>
                  )}
                </div>
              )}

              {ConfigService.checkUserPermission("gp_config") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "gp-configuration" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("gp-configuration")}
                      >
                        <SettingsSuggestIcon />
                        {/* <i className="fa fa-windows fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "gp-configuration" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("gp-configuration")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-windows fs-5" /> */}
                        <SettingsSuggestIcon />
                      </div>{" "}
                      <span>GP-Configuration</span>
                    </a>
                  )}
                </div>
              )}
              {ConfigService.checkUserPermission("banking_partner_management") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link d-flex justify-content-end ${
                        activeLink === "banking-partners" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("banking-partners")}
                      >
                        <AccountBalanceOutlinedIcon />
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link ${
                        activeLink === "banking-partners" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("banking-partners")}
                    >
                      <div className="sb-nav-link-icon">
                        <AccountBalanceOutlinedIcon />
                      </div>{" "}
                      <span>Banking Partners</span>
                    </a>
                  )}
                </div>
              )}

              {/* {ConfigService.checkUserPermission("Operation") && ( */}
              {ConfigService.checkUserPermission("Operation") && (
                <div>
                  {myClass === "sb-sidenav-toggled" && !isMobile ? (
                    <div
                      className={`nav-link  d-flex justify-content-end ${
                        activeLink === "compare-tranaction" ? "active" : ""
                      }`}
                    >
                      <div
                        className="sb-nav-link-icon w-auto"
                        onClick={() => handleLinkClick("compare-tranaction")}
                      >
                        <CompareArrowsIcon />
                        {/* <i className="fa fa-windows fs-4" /> */}
                      </div>
                    </div>
                  ) : (
                    <a
                      className={`nav-link  ${
                        activeLink === "compare-tranaction" ? "active" : ""
                      }`}
                      onClick={() => handleLinkClick("compare-tranaction")}
                    >
                      <div className="sb-nav-link-icon">
                        {/* <i className="fa fa-windows fs-5" /> */}
                        <CompareArrowsIcon />
                      </div>{" "}
                      <span>Operation</span>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </nav>
      </div>
    </>
  );
}

export default Sidebar;
